var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "arrow-left_svg__a",
  d: "M12 16c-.297 0-.578-.132-.769-.36l-5-6a1.004 1.004 0 0 1 .128-1.41 1.004 1.004 0 0 1 1.41.129L12 13.437l4.231-5.078c.354-.423.983-.48 1.41-.128.423.354.481.985.128 1.41l-5 6A1 1 0 0 1 12 16"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#arrow-left_svg__a",
  fill: "currentColor",
  fillRule: "evenodd",
  transform: "matrix(0 -1 -1 0 24 24)"
})));
export default SvgArrowLeft;